import { LegalLayout } from "@/components/LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="February 2026" testId="terms-page">
      <p>
        These Terms of Service ("Terms") form a binding agreement between you
        ("User", "you") and <strong>Brajesh Chaudhary</strong>, sole proprietor of{" "}
        <strong>Brimi AI</strong>, with registered address at 1 MP Road, Tundla,
        District Firozabad, Uttar Pradesh — 283204, India ("Brimi AI", "we", "us").
        By creating an account or using the Service you accept these Terms.
      </p>

      <h2>1. Eligibility</h2>
      <p>
        Brimi AI is intended for school students of Classes IX–XII. Users under 18
        must obtain consent from a parent or legal guardian before using the Service
        or making any payment.
      </p>

      <h2>2. Account</h2>
      <ul>
        <li>You must provide accurate, current information when registering.</li>
        <li>You are responsible for keeping your password confidential and for all activity under your account.</li>
        <li>Each account is for one individual learner. Sharing your account or login credentials with others is not permitted.</li>
      </ul>

      <h2>3. Subscription plans &amp; billing</h2>
      <ul>
        <li>New users get a <strong>20-day free trial</strong> with full feature access. No payment details are required to start the trial.</li>
        <li>After the trial, continued use requires an active paid subscription:
          <ul>
            <li><strong>Monthly:</strong> ₹299 / month</li>
            <li><strong>Yearly:</strong> ₹2,499 / year</li>
          </ul>
        </li>
        <li>All prices are in Indian Rupees (INR) and are inclusive of applicable taxes.</li>
        <li>Payments are processed securely through Razorpay. We do not store your card or UPI credentials.</li>
        <li>Subscriptions are <strong>one-time prepaid</strong> for the chosen period — they do not auto-renew. You'll see a renewal prompt when the period ends.</li>
      </ul>

      <h2>4. Refunds &amp; cancellation</h2>
      <p>
        Please see our <a href="/refund">Refund &amp; Cancellation Policy</a>. In short:
        all subscriptions are <strong>non-refundable</strong>, but you can cancel
        future renewals at any time and continue to use Brimi AI until the end of
        the current paid period.
      </p>

      <h2>5. Acceptable use</h2>
      <p>You agree NOT to:</p>
      <ul>
        <li>Use Brimi AI for any unlawful, harmful or abusive purpose.</li>
        <li>Attempt to reverse-engineer, scrape, or copy the Service or its content in bulk.</li>
        <li>Resell, sublicense or redistribute access to the Service.</li>
        <li>Submit chat prompts intended to extract another user's personal data, harass others, or generate sexually explicit, violent or otherwise illegal content.</li>
        <li>Use automated bots or scripts to access the Service.</li>
      </ul>
      <p>
        Violation of these rules may result in immediate suspension or termination
        of your account without refund.
      </p>

      <h2>6. Intellectual property</h2>
      <ul>
        <li>All Brimi AI content (UI, lesson notes, slide decks, narration audio, code) is owned by Brimi AI and protected by Indian copyright law.</li>
        <li>You may use the content for personal, non-commercial learning only.</li>
        <li>Any user-generated content (your chat messages, quiz answers) remains yours, but you grant us a non-exclusive licence to process it for the purpose of delivering the Service and improving our models.</li>
      </ul>

      <h2>7. AI-generated content disclaimer</h2>
      <p>
        Brimi AI uses large language models (Anthropic Claude, OpenAI) to generate
        responses, quizzes and slide narration. AI output can occasionally be
        inaccurate, incomplete or out-of-date. Brimi AI does not guarantee
        examination results and is <strong>not a substitute for your teacher or
        official ICSE/ISC textbooks</strong>. Always cross-check important answers
        against your prescribed material.
      </p>

      <h2>8. Service availability</h2>
      <p>
        We aim for high uptime but make no guarantee of uninterrupted access.
        Scheduled maintenance, third-party outages, or force-majeure events may
        occasionally cause downtime.
      </p>

      <h2>9. Termination</h2>
      <p>
        You may delete your account at any time by emailing{" "}
        <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a>. We may
        suspend or terminate your account if you breach these Terms.
      </p>

      <h2>10. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, Brimi AI's total liability arising
        out of or in connection with the Service shall not exceed the amount you
        paid us in the 12 months immediately preceding the claim. We are not liable
        for any indirect, incidental or consequential damages, including loss of
        marks, opportunities or data.
      </p>

      <h2>11. Governing law &amp; jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. All disputes shall be subject
        to the exclusive jurisdiction of the courts at <strong>Firozabad, Uttar Pradesh</strong>.
      </p>

      <h2>12. Changes</h2>
      <p>
        We may update these Terms from time to time. Material changes will be
        notified at least 7 days before they take effect.
      </p>

      <h2>13. Contact</h2>
      <p>
        Brajesh Chaudhary (Proprietor)<br />
        Email: <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a><br />
        Phone: +91 79836 33563<br />
        Address: 1 MP Road, Tundla, Dist. Firozabad, UP — 283204, India
      </p>
    </LegalLayout>
  );
}
